<template>
    <el-select v-model="selected" :placeholder="placeholder" @change="updateValue" :multiple="multiple " :clearable="clearable" :filterable="filterable">
        <el-option v-for="item in options"
                   :key="item[code]"
                   :label="item[label]"
                   :value="item[code]">
        </el-option>
    </el-select>
</template>

<script lang="ts">
    import { defineComponent, ref } from "vue";

    export default defineComponent({
        props: {
            value: {
                type: Number, default: null,
            },
            placeholder: {
                type: String, default: "",
            },
            code: {
                type: String, default: "id",
            },
            label: {
                type: String, default: "name",
            },
            options: {
                type: Array, default: () => []
            },
            multiple: {
                type: Boolean, default: false,
            },
            clearable: {
                type: Boolean, default: false,
            },
            filterable: {
                type: Boolean, default: true,
            }
        },
        emits: ["update:value"],
        setup(props, { emit }) {
            const selected = ref(props.value ? props.value : null);

            watch(
                () => props.value,
                (newValue) => {
                    selected.value = newValue;
                }
            );

            const updateValue = (value: number) => {
                emit("update:value", value);
                emit("change", value);
            };
           
            return {
                selected,
                updateValue
            };
        },
    });
</script>
